import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import colors from '../../utils/colors.js';
import { assetPath } from '../../utils/folders';
import { Tooltip } from '../shared/Tooltip';
import './Svg.scss';

const Svg = ({ data, className = '', fill, currentHoveringState = false, hoverable, hoverFill, onClickAction, tooltipContent }) => {
  const objectTag = useRef(null);
  const [hovering, setHovering] = useState(currentHoveringState);
  const hoverColor = hoverFill ? hoverFill : colors.hover;

  useEffect(() => {
    setFillColor();
  }, [hovering, fill]);

  const setFillColor = () => {
    if (fill) {
      window.requestAnimationFrame(() => {
        const doc = objectTag.current?.contentDocument;
        const svg = doc?.querySelector('svg');
        if (svg?.querySelector('style')) {
          svg.querySelector('style').textContent = `path { fill: ${hoverable && hovering ? hoverColor : fill} }`;
        } else if (svg) {
          const styleElement = doc.createElementNS('http://www.w3.org/2000/svg', 'style');
          doc.querySelector('svg').appendChild(styleElement);
          styleElement.textContent = `path { fill: ${fill} }`;
        }
      });
    }
  };
  const object = (
    <object
      id={className}
      ref={objectTag}
      className={`svg ${className}`}
      onLoad={setFillColor}
      data={assetPath(data)} type='image/svg+xml'
    />
  );

  return (
    <span className={className}
      onMouseEnter={() => setHovering(true)}
      onMouseOut={() => setHovering(false)}
      onClick={onClickAction}
    >
      { tooltipContent ?
        <Tooltip id={className} textContent={tooltipContent}>
          {object}
        </Tooltip> : object
      }
    </span>
  );
};

Svg.propTypes = {
  data: PropTypes.string.isRequired,
  className: PropTypes.string,
  fill: PropTypes.string,
  currentHoveringState: PropTypes.bool,
  hoverable: PropTypes.bool,
  hoverFill: PropTypes.string,
  onClickAction: PropTypes.func,
  tooltipContent: PropTypes.any,
};

export default Svg;
